import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

const Booking = () => {
    const { serviceId } = useParams();
    const [service, setService] = useState({});

    useEffect(() => {
        const url = `https://serene-beach-92273.herokuapp.com/services/${serviceId}`;
        fetch(url)
            .then(res => res.json())
            .then(data => setService(data))
    }, []);

    return (
        <div className='container mt-5'>
            <h2>{service.name}</h2>
            <img src={service.img} alt="" />
            <p>{service.description}</p>
            <p>Price: ${service.price}</p>
        </div>
    );
};

export default Booking;